module.exports = __webpack_public_path__ + "img/Pot3.6ec4d612.svg";